import { Navigate } from 'react-router-dom'
import { IDM_CREATE_ROUTE } from '../../app/router/routes'

export default function AdminChangePage() {
    return <Navigate to={IDM_CREATE_ROUTE.path} replace />
}
